<!--suppress ALL -->
<template>
  <g-field :label="label" :type="type" :message="message">
    <g-field is-grouped>
      <g-select @change="onSelected" is-fullwidth :value="itemNama || ''"
                :placeholder="itemPembayarans.length === 0 ? $t('text.no_content_loaded') :
                `${placeholder}`" class="control is-expanded">
        <option v-for="value in itemPembayarans"
                :value="value.nama" :key="value.id">
          {{ value.penerima }} - {{ value.nama }}
        </option>
      </g-select>
      <div v-if="isLoading" class="control">
        <g-button type="light">
          <span class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </g-button>
      </div>
    </g-field>
  </g-field>
</template>

<script lang="ts">
import {Component, Vue, Prop} from 'annotation';
import {cloneDeep} from 'lodash';
import Store from "../../../util/Store";
import NamaItemPembayaran from "../../../entity/NamaItemPembayaran";
import Authentication from "../../../Authentication";
import {getJenisKelaminWilayah} from '../../../util/PluralVariabels';

@Component
export default class NamaItemPembayaranSelect extends Vue {

  @Prop({default: "", type: String})
  public itemNama: string;

  @Prop({default: "Nama", type: String})
  public label: string;

  @Prop({default: "Nama pembayaran", type: String})
  public placeholder: string;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  public get itemPembayarans() {
    let posts: Array<NamaItemPembayaran> = Store.getVmProperty('namaItemPembayaran.data', []);
    return posts;
  }

  public isLoading: boolean = false;

  public created() {
    const penerima = Authentication.getUser().roles[0]
    const kelamin = getJenisKelaminWilayah(penerima)

    Store.dispatchNamaItemPembayaran(false, kelamin, penerima);
  }

  public onSelected(nama: string) {
    const itemPembayaranSelect: NamaItemPembayaran = this.itemPembayarans.find((item: NamaItemPembayaran) => item.nama === nama) ||
        new NamaItemPembayaran();

    this.$emit('item-selected', cloneDeep(itemPembayaranSelect));
  }
}
</script>
